var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ItemBase } from '../../../models/item/item-base';
var TextOperatorComponent = /** @class */ (function (_super) {
    __extends(TextOperatorComponent, _super);
    function TextOperatorComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cols = [];
        return _this;
    }
    TextOperatorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var type = this.col.controlType.replace(/Operator$/, '');
        this.cols = [];
        this.cols.push(Object.assign(new ItemBase(), {
            key: this.col.key,
            controlType: 'text',
            params: this.col.params
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$operator.' + this.col.key,
            controlType: 'select',
            required: true,
            params: {
                options: [
                    { code: 'eq', display: this.msg['TextOperatorComponent.select.eq'] },
                    { code: 'like', display: this.msg['TextOperatorComponent.select.like'] },
                    { code: 'prefix', display: this.msg['TextOperatorComponent.select.prefix'] },
                    { code: 'suffix', display: this.msg['TextOperatorComponent.select.suffix'] }
                ]
            }
        }));
        var operator = (this.col.params && this.col.params.operator ? this.col.params.operator : {});
        if (Object.keys(operator).length > 0 && (operator.readonly || operator.hidden)) {
            this.changeVal.emit({ key: '$operator.' + this.col.key, val: operator.value });
        }
    };
    TextOperatorComponent.prototype.onChangeVal = function (e) {
        this.changeVal.emit(e);
    };
    TextOperatorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-text-operator',
                    template: "<ul *ngIf=\"cols.length > 0\">\n  <li [key]=\"key\" [col]=\"col\" [val]=\"val\" columnDir>\n    <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[0]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n  </li>\n  <li *ngIf=\"!col.params?.operator?.readonly && !col.params?.operator?.hidden\" class=\"form_li\">\n    <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[1]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n  </li>\n  <li *ngIf=\"col.params?.operator?.readonly\" class=\"form_li\">\n    <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[1]\" [val]=\"val['$operator.' + col.key]\" [msg]=\"msg\"></column-formlabel>\n  </li>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    TextOperatorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return TextOperatorComponent;
}(ColumnBaseComponent));
export { TextOperatorComponent };
//# sourceMappingURL=text-operator.component.js.map